import React from 'react';
import { connect } from 'redux-bundler-react';

class LoadingIndicator extends React.Component {
  render(){
    const { isLoading, isLoadingText } = this.props;
    if(!isLoading) return null;
    return (
      <div style={{position: 'absolute', top:0, bottom:0, left:0, right:0, backgroundColor:'rgba(255,255,255,0.2)', zIndex:9999999999}}>
        <div className="loading-container" style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color:'#333333', fontWeight:'bold'}}>
          <div className="loading-spinner">
          </div>
          <div className="loading-text">
            {isLoadingText}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectIsLoading',
  'selectIsLoadingText',
  LoadingIndicator
)
